module.exports = __webpack_public_path__ + "img/Villa_Borna_63.2edbf098.jpg";